import React from "react"
import PropTypes from "prop-types"
import EntryExitTableRow from "./EntryExitTableRow.js";
import { formatAccessCredential } from "../Helper"

class MemberDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transitId: window.memberDetailsTransitId,
      isLoading: false,
      memberDetails: null,
      editingVehicle: null
    };
    this.handleSave = this.handleSave.bind(this);
    this.fetchMemberDetails = this.fetchMemberDetails.bind(this);
    this.updatePermitBusy = this.updatePermitBusy.bind(this);
  }

  render () {
    const message = this.state.errorMessage || ""
    if (this.state.isLoading) {
      return (
      <React.Fragment>
      <div id="member-details-inner" className="loading" >
        <img className="spinner" src="/assets/spinner.gif"/> Loading...
      </div>
      </React.Fragment>
      )
    }
    else if (this.state.memberDetails === null) {
      return (
        <React.Fragment>
          <div className="done-loading">No member details found.</div>
        </React.Fragment>
      )
    }
    else {
      var vehicle_rows = [];
      var permit_rows = [];
      if (this.state.memberDetails.permits != null && this.state.memberDetails.permits.length > 0) {
        for (var i = 0; i < this.state.memberDetails.permits.length; i++) {
          var permit = this.state.memberDetails.permits[i];
          permit_rows.push(
                <tr key={i}>
                  <td>{permit.permit_identifier}</td>
                  <td>{permit.state}</td>
                  <td>{permit.garage_name} </td>
                  <td>{permit.tenant} </td>
                  <td>{permit.access_level} </td>
                </tr>
          )
        }        
      }
      else {
        permit_rows = [(<tr key={1}><td colSpan="5">No permits</td></tr>)]
      }
      console.log("vehicles: "+JSON.stringify(this.state.memberDetails.vehicles, null, 2));
      if (this.state.memberDetails.vehicles != null && this.state.memberDetails.vehicles.length > 0) {
        for (var i = 0; i < this.state.memberDetails.vehicles.length; i++) {
          var vehicle = this.state.memberDetails.vehicles[i];
          console.log("vehicle: "+JSON.stringify(vehicle, null, 2));
          if (this.state.editingVehicle != null && this.state.editingVehicle.id == vehicle.id) {
            vehicle_rows.push(
                <tr key={i}>
                  <td>
                    <input
                     style={{width: "30px", backgroundColor: "#f0f0f0"}}
                     type='text'
                     name='state'
                     value={this.state.editingVehicle.state}
                     onChange={e => this.setState({editingVehicle: {...this.state.editingVehicle, state: e.target.value}})}             
                    />&nbsp;
                    <input
                     style={{width: "70px", backgroundColor: "#f0f0f0"}}
                     type='text'
                     name='state'
                     value={this.state.editingVehicle.plate}
                     onChange={e => this.setState({editingVehicle: {...this.state.editingVehicle, plate: e.target.value}})}             
                    />&nbsp;
                  <input type="button" value="Save" onClick={this.handleSave} />&nbsp;
                  <input type="button" value="Cancel" onClick={e => this.setState({editingVehicle: null})} />
                  </td>
                  <td>{vehicle.tag_id}</td>
                  <td>{vehicle.make}</td>
                  <td>{vehicle.model}</td>
                </tr>
            )
          }
          else {
            vehicle_rows.push(
                <tr key={i}>
                  <td>({vehicle.state}) {vehicle.plate}
                    <input type="button" value="Edit" onClick={this.setEditingVehicle.bind(this, vehicle)} />
                  </td>
                  <td>{vehicle.rfid || "--"}</td>
                  <td>{vehicle.make}</td>
                  <td>{vehicle.model}</td>
                </tr>
            )
          }
        }
      }
      else {
        vehicle_rows = [(<tr key={1}><td colSpan="4">No vehicles</td></tr>)]
      }

      return (
        <React.Fragment>
        <div id="member-details-inner" className="done-loading">
          <p style={{color: "red"}}>{message}</p>          
          <form>
            <p>Account Details: {this.state.memberDetails.name}</p>
            <p>User: {this.state.memberDetails.email}</p>
            <p>Contact: {this.state.memberDetails.phone}</p>
            <p>Wallet: {this.state.memberDetails.wallet}</p>

            <table className="table table-bordered">
            <thead>
              <tr>
                <td colSpan="4">
                  <strong>Vehicles</strong>
                </td>
              </tr>
              <tr>
                <td>Plate#</td>
                <td>Tag ID</td>
                <td>Make</td>
                <td>Model</td>
              </tr>
            </thead>
            <tbody>
            {vehicle_rows}
            </tbody>
          </table>

          <table className="table table-bordered">
            <thead>
              <tr>
                <td colSpan="4">
                  <strong>Permits</strong>
                </td>
              </tr>
              <tr>
                <td>Permit ID</td>
                <td>Status</td>
                <td>Garage</td>
                <td>Tenant</td>
                <td>Level</td>
              </tr>
            </thead>
            <tbody>
            {permit_rows}
            </tbody>
          </table>

          </form>

          <p>Last 15 Transits</p>

          <table className="table table-hover" id="transit-view">
            <thead>
              <tr>
                <th>Date/Time In</th>
                <th>Date/Time Out</th>
                <th>Plate #</th>
                <th>Access</th>
                <th>Duration</th>
                <th>Fee</th>
                <th>Transit Type</th>
                <th>Transaction ID</th>
              </tr>
            </thead>
            <tbody className="transit-list" id="transit-list">
              {this.state.memberDetails.transits.map((transit, _index) => (
                <EntryExitTableRow
                  key={transit.id}
                  duration_in_time={transit.formatted_duration}
                  entry_mechanism={transit.entry_mechanism}
                  local_entry_time={transit.formatted_entry_time}
                  local_exit_time={transit.formatted_exit_time}
                  garage_id={transit.garage_id}
                  payment={transit.payment}
                  transaction_id={transit.transaction_id}
                  transit_id={transit.id}
                  access_credential={formatAccessCredential(transit)}
                  vehicle_state_and_plate={transit.formatted_plate}
                  lpr_filename={transit.lpr_filename}
                  closed_transit={
                    transit.entry_transit !== null &&
                    transit.exit_transit !== null
                  }
                  permit_busy_valid={transit.permit_busy_valid}
                  entered_before_cleared_inventory={transit.entered_before_cleared_inventory}
                  transit_type={transit.transit_type}
                  clickHandler={() => console.log("ignoring row click handler from member details")}
                  validClickHandler={this.updatePermitBusy}
                />
              ))}
            </tbody>
          </table>
        </div>
        </React.Fragment>

      )






    }
  }

  setEditingVehicle(vehicle) {
    this.setState({editingVehicle: vehicle})
  }

  componentDidMount() {
     this.fetchMemberDetails();
  }
  
  closeDialog() {
    $("#modal-member-details").modal("hide");
  }
  
  async handleSave() {
    var url = "/api/v2/vehicles/"+this.state.editingVehicle.id+".json"
    this.setState({...this.state, isLoading: true}, () => {      
      fetch(url, {
          method: "PUT",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.state.editingVehicle)
        })
        .then((response) => {
          console.log("got response: "+response.status+" : "+response.statusText);
          if (![200, 204, 422].includes(response.status)) { throw Error("Code "+response.status+" : "+response.statusText); }
          return response;
        })
        .then(response => response.json())
        .then(data=> {
          console.log("data: "+JSON.stringify(data, null, 2));
          if ('errorMessage' in data) {
            // Handle error
            this.setState({errorMessage: data.errorMessage, isLoading: false})
          } else {
            this.setState({errorMessage: "Vehicle updated successfully!", editingVehicle: null})
            this.fetchMemberDetails();
          }
        })
        .catch((error) => {
          console.error("catch error block with :"+error);
          this.setState({...this.state, errorMessage:  "Error:  "+error, isLoading: false})
        })
        .finally(() => {
          this.setState({...this.state, isLoading: false})
        })
    })
  }

  updatePermitBusy(garageId, transitId) {
    console.log("updatePermitBusy called with garageId: "+garageId+" transitId: "+transitId); 
    var url = "/garages/"+garageId+"/transits/"+transitId
    this.setState({...this.state, isLoading: true}, () => {      
      fetch(url, {
          method: "PATCH",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          console.log("got response: "+response.status+" : "+response.statusText);
          if (![200, 204, 422].includes(response.status)) { throw Error("Code "+response.status+" : "+response.statusText); }
          return response;
        })
        .then(response => response.json())
        .then(data=> {
          console.log("data: "+JSON.stringify(data, null, 2));
          if ('errorMessage' in data) {
            // Handle error
            this.setState({errorMessage: data.errorMessage, isLoading: false})
          } else {
            this.setState({errorMessage: "Permit Busy Valid updated successfully"})
            this.fetchMemberDetails();
          }
        })
        .catch((error) => {
          console.error("catch error block with :"+error);
          this.setState({...this.state, errorMessage:  "Error:  "+error, isLoading: false})
        })
        .finally(() => {
          this.setState({...this.state, isLoading: false})
        })
    })
  }

  fetchMemberDetails() {    
    var that = this;
    var url = "/account_details.json?transit_id=" + that.state.transitId

    var responseAfterPromise = null;
    that.setState({isLoading: true, errorMessage: null});

    console.log("url: "+url);

    fetch(url).then(response => {
          if (response.status == 200) {
            response.json().then(json => {
              if (json.errors && typeof json.errors === 'object' && json.errors.constructor === Array && json.errors.length > 0) {
                errorMessage = json.errors.join("; ");
                that.setState({memberDetails: null, isLoading: false, errorMessage: errorMessage});
                return Promise.reject(new Error(errorMessage))
              }
              else {
                that.setState({memberDetails: json, isLoading: false, errorMessage: null});
                return Promise.resolve(json)
              }
            })
            .catch(function(error) {
	          that.setState({isLoading: false});
	          var errorString = ""+error;
               that.setState({memberDetails: null, isLoading: false, errorMessage: ''+error});
            });
          }
          else {
            errorMessage = "System error: "+response.statusText;
            that.setState({memberDetails: null, isLoading: false, errorMessage: errorMessage});
          }
      });
  }
}

MemberDetails.propTypes = {
  greeting: PropTypes.string
};
export default MemberDetails